// ** react imports
import React from 'react';
import PropTypes from 'prop-types';

// ** enums imports
import { BUTTON_THEMES } from '../../../../enums/common';

// ** component imports
import NormalButton from '../../../common/Buttons/NormalButton';

// ** context imports
import { useDocument } from '../../../../contexts/DocumentContext';

const OfficeDocumentsHeader = () => {
  // hooks
  const {
    isHistoryMode,
    toggleUploaderVisibility,
    isUploadTaxFileDocumentLoading,
    isUploaderVisible,
    toggleHistoryMode,
  } = useDocument();

  return (
    <div className="px-4 py-4 sm:px-6 sm:py-5 bg-gradient-to-r from-emerald-50 to-teal-50 dark:from-emerald-900/20 dark:to-teal-900/20 border-b border-gray-200 dark:border-gray-700">
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
        <div className="flex items-center space-x-3 sm:space-x-4">
          <div className="w-10 h-10 sm:w-12 sm:h-12 bg-gradient-to-br from-emerald-500 to-teal-600 rounded-xl flex items-center justify-center shadow-lg flex-shrink-0">
            <svg
              className="w-5 h-5 sm:w-6 sm:h-6 text-white"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M8 10h.01M12 10h.01M16 10h.01M9 16H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-5l-5 5v-5z"
              />
            </svg>
          </div>
          <div>
            <h2 className="text-lg sm:text-xl font-bold text-gray-800 dark:text-gray-100 tracking-wide">
              IN-OFFICE DOCUMENTS
            </h2>
            <p className="text-xs sm:text-sm text-gray-600 dark:text-gray-400 mt-1">
              Review and modify in-office documents
            </p>
          </div>
        </div>{' '}
        {/* Closing tag for the first div inside flex container */}
        <div className="flex items-center space-x-2">
          {isUploaderVisible && (
            <NormalButton
              theme={BUTTON_THEMES.TERTIARY}
              onClick={toggleHistoryMode}
              className="text-sm whitespace-nowrap"
            >
              <svg
                className="shrink-0 fill-current"
                width="21"
                height="21"
                viewBox="0 0 16 16"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  fill="currentColor"
                >
                  {isHistoryMode ? (
                    <path d="M17 17V19C17 19.5523 17.4477 20 16 20C18.5523 20 19 19.5523 19 19V4H5V15H3V3C3 2.44772 3.44772 2 4 2H20C20.523 2 21 2.44772 21 3V19C21 20.6569 19.6569 22 18 22H4C2.34315 22 1 20.6569 1 19V17H17Z"></path>
                  ) : (
                    <path d="M6 4H4V2H20V4H18V6C18 7.61543 17.1838 8.91468 16.1561 9.97667C15.4532 10.703 14.598 11.372 13.7309 12C14.598 12.628 15.4532 13.297 16.1561 14.0233C17.1838 15.0853 18 16.3846 18 18V20H20V22H4V20H6V18C6 16.3846 6.81616 15.0853 7.8439 14.0233C8.54682 13.297 9.402 12.628 10.2691 12C9.40202 11.372 8.54682 10.703 7.8439 9.97667C6.81616 8.91468 6 7.61543 6 6V4ZM8 4V6C8 6.88457 8.4384 7.71032 9.2811 8.58583C10.008 9.33699 10.9548 10.0398 12 10.7781C13.0452 10.0398 13.992 9.33699 14.7189 8.58583C15.5662 7.71032 16 6.88457 16 6V4H8ZM12 13.2219C10.9548 13.9602 10.008 14.663 9.2811 15.4142C8.43384 16.2897 8 17.154 8 18V20H16V18C16 17.1154 15.5662 16.2897 14.7189 15.4142C13.992 14.663 13.0452 13.9602 12 13.2219Z"></path>
                  )}
                </svg>
              </svg>
            </NormalButton>
          )}

          {!isHistoryMode && isUploaderVisible && (
            <NormalButton
              theme={BUTTON_THEMES.PRIMARY}
              className="text-sm whitespace-nowrap"
              onClick={toggleUploaderVisibility}
            >
              Add Document
            </NormalButton>
          )}
          {!isHistoryMode && !isUploaderVisible && (
            <NormalButton
              theme={BUTTON_THEMES.DANGER}
              className="text-sm whitespace-nowrap"
              onClick={toggleUploaderVisibility}
              disabled={isUploadTaxFileDocumentLoading}
            >
              Cancel
            </NormalButton>
          )}
        </div>
      </div>
    </div>
  );
};

OfficeDocumentsHeader.propTypes = {};

export default OfficeDocumentsHeader;
